// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2YAyQ","amount":"Amount_amount__3awLT","tip":"Amount_tip__3QoO1","tipHeader":"Amount_tipHeader__1VZoj","tipsWrap":"Amount_tipsWrap__2vd5P"};